import { useEffect } from "react"
import useShowPopup from "../pcWarningPopup/useShowPopup"
const useSorryPop = (props:any) => {
    const {dispatch,otherWebInPopupFirstShow,sorrypop} = props
    if(sorrypop.data){
        dispatch({
            type: 'headInfo/changeOtherWebInPopup',
            payload:true
          })
    }else{
        useShowPopup(props)
    }
}

export default useSorryPop;